import {QuestionWithAnswer} from './question-with-answer.model';

export class AnsweredQuestions {
  public answers: QuestionWithAnswer[] = [];

  public addQuestionWithAnswer(questionWithAnswer: QuestionWithAnswer) {
    this.answers.push(questionWithAnswer);
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/models/answered-questions.model.ts